import { FC } from 'react';
import { UIText2 } from '@cian/ui-kit';
import styles from './style.css';

export const MortgagePaymentInputAdornment: FC = () => {
  return (
    <div className={styles['container']}>
      <UIText2>₽/мес</UIText2>
    </div>
  );
};
